var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile)?_c('div',{staticClass:"mobile-warning"},[_vm._v(" This tool cannot be used on a mobile device. Please access using a computer browser. ")]):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }